import React from 'react';
import { FormattedMessage } from 'react-intl';

const CommunicationSettingsIntroduction = () => {
  return (
    <>
      <div>
        <FormattedMessage
          id="user.communication-settings.introduction.first-paragraph"
          defaultMessage="According to the Privacy Policy and the User Terms of Use, GPI and our partners (if any) may contact you via e-mail on relevant matters in relation to the platform, for example, support, etc."
          tagName="strong"
        />
      </div>
      <br />
      <div>
        <FormattedMessage
          id="user.communication-settings.introduction.second-paragraph"
          defaultMessage="Please select which additional information you would like to receive via e-mail:"
          tagName="strong"
        />
      </div>
    </>
  );
};

export default CommunicationSettingsIntroduction;
